module.exports = __webpack_public_path__ + "img/linkedin-box-fill.95fc43aa.svg";